export default {
    selectDateAndTime: {
        'en': 'Select date & time',
        'nl': 'Selecteer een datum & tijd',
    }
}